<!-- 人事类特殊申请 -->
<template>
	<div class="pages">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' :data-val='item'></Table>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
		</div>


		<Button class="submit-process" v-on:click='submit' size="large" v-bind:loading="formLoading" type="primary"> 提交 </Button>

		<Spin size="large" fix v-if="spinShow"></Spin>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Textarea from '../components/Textarea.vue';

	import stringUtils from "../assets/js/stringUtil.js";
    import { submitProcess } from '@/api/approval'
	var templateData = {
		TemplateContent: {
			Controls: []
		}
	};
	var logInfo = null;
	
	import {
		formatDate
	} from '@/utils/date'
	import {
		getRelationList
	} from '@/utils/processcondtion'
	import {
		getRelation
	} from '@/api/employee'
	var isSubmit = false;

	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Textarea
		},
		data() {
			return {
				"templateData": templateData,
				spinShow: true,
				formLoading:false,
				templateId:null,
				spNo: null,
				flowId:null,
				relationList:[]
			}
		},
		mounted() { //页面挂载
			//initWxConfig(this);
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			logInfo = JSON.parse(localStorage.getItem('logInfo'));
			if (logInfo == null) {
				logInfo = JSON.parse(stringUtils.getCookies("logInfo"));
			}
			let that = this;
			getRelation(logInfo.EmpNo).then(response => {
					this.relationList = response.Body[0].Nodes;
					that.getTemplate();
			})
		},
		created() {
			
		},
		methods: { 
			getTemplate:async function() {
				let that = this;
				that.$http({
					url: that.$httpUrl.getTemplate + "?templateId=" + stringUtils.GetQueryString("templateId"),
					method: "get",
				}).then(async res => {
					if (res.data == null || res.data.ErrCode != 0) {
						that.$Message.error({
							background: true,
							content: '模板获取错误'
						});
						return;
					}
					var controls =res.data.Body;
					that.templateData = res.data.Body;
					if (that.templateData == null) {
						alert("模板获取错误");
						return;
					}
					for (var i = 0; i < that.templateData.TemplateContent.Controls.length; i++) {
						if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "部门") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.DeptName;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "人员") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.EmpName;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "工号") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.EmpNo;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "申请时间") {
							let date = new Date();
							that.templateData.TemplateContent.Controls[i].Value = formatDate(date,"yyyy-MM-dd");
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "逐级审批") {
							that.templateData.TemplateContent.Controls[i].IsShow = false;
							let l = getRelationList(this.relationList,8);
							if(!l || !l.length){
								l = [that.$store.state.defaultMember]
							}
							console.log('ll',l);
							that.templateData.TemplateContent.Controls[i].Values=l;
						}
					}
					that.spinShow = false;
					this.templateData = await this.assignControlBySpNo(controls, this.spNo);
				}, err => {
					console.log(err)
				});
			},
			getTextVal() {
			},
			submit() {
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				// 申请部门
				// 需要开具收入
				// 本人实际收入
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];

				var control1=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "部门"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"部门："+control1.Value ,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control2=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "人员"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"人员："+control2.Value ,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control4=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请时间"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请时间："+control4.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				this.templateData.SummaryList=SummaryList;
				
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
				}
				isSubmit = true;
				this.formLoading = true;
				//提交
				submitProcess(this.templateId, logInfo.EmpNo, this.spNo, this.templateData).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.formLoading = false;
				});
			}
		}
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
